export const VERSION = APP_VERSION;
export const BUILD_TIMESTAMP = APP_BUILD_TIME;
